<template>
  <DialogFull :data="dialogSettings" @close="close">
    <div class="container col-lg-8 col-sm-12">
      <Experience @close="close" submitButtonTitle="Save Changes" />
    </div>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import Experience from "@/views/profile/QuestionsAndAnswers/steps/Experience/Experience";

export default {
  components: {
    DialogFull,
    Experience
  },
  props: {
    isOpen: Boolean
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Experience"
      };
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
